import axios from "axios";
import cloneDeep from "lodash/cloneDeep";

const state = {
  productsAll: null,
  oldRequestedProduct: [],
  productsStatus: false,
  productsMaxPrice: 50000,
  searchResult: null,
  savedProductInfo: null,
  searchStatus: false,
  color_range: null,
  products_size: null,
  priceFilter: null,
};

const getters = {
  getSavedProductInfo(state) {
    return state.savedProductInfo;
  },
  getProductsAll(state) {
    return state.productsAll;
  },
  getPriceFilter(state) {
    return state.priceFilter;
  },
  getProductsColorRange(state) {
    return state.color_range;
  },
  getProductsSize(state) {
    return state.products_size;
  },
  getProductsStatus(state) {
    return state.productsStatus;
  },
  getProductsMaxPrice(state) {
    return state.productsMaxPrice;
  },
  // دریافت نتیج جستوجو
  getSearchResult(state) {
    return state.searchResult;
  },
  // دریافت استاتوس نتیج جستوجو
  getSearchStatus(state) {
    return state.searchStatus;
  },
};

const mutations = {
  changeOldRequestList(state, newValue) {
    let lastValue = state.oldRequestedProduct;
    lastValue.push(newValue);
    state.oldRequestedProduct = lastValue;
  },
  setProductLinkedInfo(state, product) {
    state.savedProductInfo = product;
  },
  setPriceFilter(state, priceFilter) {
    state.priceFilter = priceFilter;
  },
  setProductsColorRange(state, colorRange) {
    state.color_range = colorRange;
  },
  setProductsSize(state, sizes) {
    state.products_size = sizes;
  },
  setProductsAll(state, products) {
    state.productsAll = products;
  },
  setProductsStatus(state, status) {
    state.productsStatus = status;
  },
  setProductsMaxPrice(state, price) {
    state.productsMaxPrice = price;
  },
  // ست کردن نتایج جستوجو
  setSearchResult(state, list) {
    state.searchResult = list;
  },
  setSearchStatus(state, status) {
    state.searchStatus = status;
  },
};

const actions = {
  async getProductFromServer({ commit, state }, id) {
    let finded = state.oldRequestedProduct.find((request) => {
      if (request.key == JSON.stringify({ id: id })) {
        return request;
      }
    });
    if (finded) {
      return finded.value;
    } else {
      let res = await axios.get(`front/products/${id}`);
      commit("changeOldRequestList", {
        key: JSON.stringify({ id: id }),
        value: res,
      });
      return res;
    }
  },
  // اکشن جستوجو در میان محصولات
  async searchInProducts({ commit }, search) {
    commit("setSearchStatus", true);
    await axios.get("/front/products/search?q=" + search).then((response) => {
      commit("setSearchStatus", false);
      commit("setSearchResult", response.data.data.products);
    });
  },
  async getpeoductDataColorRanges({ commit }) {
    await axios.get("/front/color-ranges").then((response) => {
      commit("setProductsColorRange", response.data.data.colorRanges);
    });
  },
  async getProductsDataFromServer({ commit }, payLoad) {
    let queryRoute = payLoad.query;
    console.log(queryRoute,"dfadsfdfdsfdsfdsfdsfdsfdsfdsf");
    let query = {
      page: queryRoute.query.page ?? 1,
      sort: queryRoute.query.sort ?? "",
      title: queryRoute.query.title ?? "",
      flash_id: queryRoute.query.flash_id ?? "",
      max_price: queryRoute.query.max_price ?? 0,
      min_price: queryRoute.query.min_price ?? 0,
      available: queryRoute.query.available ? 1 : 0,
      category_id: queryRoute.params.category ?? "",
      // selected_sizes: Array(20).fill(false),
      // color_ids: [],
      color_range_ids: [],
      attribute_value_id: [],
    };
    if (queryRoute.query.size) {
      let sizes = queryRoute.query.size;
      let ArraySizes = sizes.split(",");
      query.attribute_value_id = ArraySizes;
    }
    if (queryRoute.query.color_rang) {
      let colorsRang = queryRoute.query.color_rang;
      let ArrayColorRang = colorsRang.split(",");
      query.color_range_ids = ArrayColorRang;
    }

    // delete query.selected_sizes;
    // query.attribute_value_id = payLoad.selectedAttributeValueIds;

    commit("setProductsStatus", true);
    // let finded = state.oldRequestedProduct.find((request) => {
    //   if (request.key == JSON.stringify(query)) {
    //     return request;
    //   }
    // });
    // if (finded) {
    //   commit("setProductsAll", finded.value);
    // } else {
    try {
      const response = await axios.get("front/products", {
        params: query,
      });

      commit("setProductsSize", response.data.data.attributes);
      commit("setPriceFilter", response.data.data.priceFilter);
      commit("setProductsAll", response.data.data.products);
      commit("changeOldRequestList", {
        key: JSON.stringify(query),
        value: response.data.data.products,
      });
      setTimeout(() => {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
      if (response.data.data.priceFilter.max_price > 50000) {
        let max =
          Math.ceil(response.data.data.priceFilter.max_price / 1000) * 1000;
        commit("setProductsMaxPrice", max);
      }
      commit("setProductsStatus", false);
    } catch (error) {
      console.log(error);
    }
    // }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
